import { render, staticRenderFns } from "./OrderFeedbackComment.vue?vue&type=template&id=b3b62a56&scoped=true"
import script from "./OrderFeedbackComment.vue?vue&type=script&lang=js"
export * from "./OrderFeedbackComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b62a56",
  null
  
)

export default component.exports